var _style, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse, _path23, _g2, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHighQuality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{opacity:0.37;fill:#FFFFFF;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:#BDD0FB;}\n\t.st7{fill:url(#SVGID_5_);}\n\t.st8{fill:url(#SVGID_6_);}\n\t.st9{fill:url(#SVGID_7_);}\n\t.st10{fill:url(#SVGID_8_);}\n\t.st11{fill:url(#SVGID_9_);}\n\t.st12{opacity:0.43;fill:#FFFFFF;}\n\t.st13{fill:url(#SVGID_10_);}\n\t.st14{opacity:0.2;fill:url(#SVGID_11_);}\n\t.st15{fill:url(#SVGID_12_);}\n\t.st16{fill:#7D97F4;}\n\t.st17{fill:url(#SVGID_13_);}\n\t.st18{fill:url(#SVGID_14_);}\n\t.st19{fill:url(#SVGID_15_);}\n\t.st20{fill:url(#SVGID_16_);}\n\t.st21{fill:url(#SVGID_17_);}\n\t.st22{opacity:0.12;fill:#FFFFFF;}\n\t.st23{fill:url(#SVGID_18_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 655,
    height: 112,
    xlinkHref: "5C6A4FAC.png",
    transform: "matrix(0.1939 0 0 0.1939 42.2901 -44.7143)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.2
    },
    width: 697,
    height: 462,
    xlinkHref: "5C6A4FB8.png",
    transform: "matrix(0.24 0 0 0.24 2.28 24.12)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.8546,
    y1: 115.2069,
    x2: 79.0463,
    y2: 18.3908
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M138,105.2c0,1.2-1,2.1-2.1,2.1H19.7c-1.2,0-2.1-1-2.1-2.1l-1-66.8c0-1.2,1.4-3.5,3.9-3.3L134,32.2 c1.5,0,2.9,0.5,4,1.6c1,1,1.6,2.5,1.6,4L138,105.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 128.3435,
    y1: 14.4597,
    x2: -23.0025,
    y2: 187.3225
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M135.9,103.1c0,1.1-0.9,2-2,2H22.5c-1.1,0-2-0.9-2-2l-0.9-60.6c0.1-3.6,3.3-5,5.2-4.9 c0,0,88.7-2.4,108.8-2.9c1,0,2,0.4,2.8,1.1c0.7,0.7,1.1,1.7,1.1,2.8L135.9,103.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21.7,74.2c-0.1,0-0.2-0.1-0.2-0.2l-0.1-4.9c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0c0.1,0,0.2,0.1,0.2,0.2 l0.1,4.9C21.8,74.1,21.7,74.2,21.7,74.2C21.7,74.2,21.7,74.2,21.7,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21.5,62.1c-0.1,0-0.2-0.1-0.2-0.2L21,43.2c0-1.3,0.4-2.3,1.1-3c1.4-1.3,3.5-1.3,3.6-1.2L60.6,38 c0.1,0,0.2,0.1,0.2,0.1c0,0.1-0.1,0.2-0.1,0.2l-34.8,0.9c-0.1,0-2.1-0.1-3.4,1.2c-0.7,0.7-1,1.6-1.1,2.8L21.6,62 C21.6,62.1,21.6,62.1,21.5,62.1C21.5,62.1,21.5,62.1,21.5,62.1z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.4,99.8c0.1-5,0.1-49.4-0.2-53.2c-0.3-3.8,5.7-4.5,14.8-5c9.2-0.4,86.4-2.1,88.4-2.3 c4.5-0.4,5.4,6.3,5,20.8C133,71,132.5,89,132.2,97.2c-0.1,2.5-2.1,4.4-4.5,4.4c-18.6,0.1-89.9,0.3-94.6,0.4 C27.6,102.2,25.3,101.7,25.4,99.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.9466,
    y1: 42.3652,
    x2: 78.9466,
    y2: 106.9091
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M145.5,112.9H12.4c-1.1,0-1.9-0.9-1.9-1.9v-2c0-1.1,0.9-1.9,1.9-1.9h133.1c1.1,0,1.9,0.9,1.9,1.9v2 C147.4,112,146.6,112.9,145.5,112.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.2
    },
    width: 424,
    height: 441,
    xlinkHref: "5C6A4FB9.png",
    transform: "matrix(0.24 0 0 0.24 31.32 18.12)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.1353,
    y1: 4.8782,
    x2: 14.3429,
    y2: 208.199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M93.5,101.8H56.9c-9.7,0-17.5-7.8-17.5-17.5V43.7c0-9.7,7.8-17.5,17.5-17.5h36.6c9.7,0,17.5,7.8,17.5,17.5 v40.5C111,94,103.1,101.8,93.5,101.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.3,99.8H48.2c-3,0-5.4-2.4-5.4-5.4V33.8c0-3,2.4-5.4,5.4-5.4h54.1c3,0,5.4,2.4,5.4,5.4v60.6 C107.7,97.4,105.3,99.8,102.3,99.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.6195,
    y1: 55.3957,
    x2: 101.5314,
    y2: 55.3957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M94.4,70H56.8c-4,0-7.2-3.2-7.2-7.2v-15c0-4,3.2-7.2,7.2-7.2h37.6c4,0,7.2,3.2,7.2,7.2v15 C101.5,66.8,98.3,70,94.4,70z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 44.9981,
    y1: 32.6027,
    x2: 87.7973,
    y2: 32.6027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M86.7,34.8H46.1c-0.6,0-1.1-0.5-1.1-1.1v-2.3c0-0.6,0.5-1.1,1.1-1.1h40.6c0.6,0,1.1,0.5,1.1,1.1v2.3 C87.8,34.3,87.3,34.8,86.7,34.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 89.9073,
    y1: 32.6639,
    x2: 93.5587,
    y2: 32.6639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M91.7,34.4c-1,0-1.8-0.8-1.8-1.7c0-0.9,0.8-1.7,1.8-1.7s1.8,0.8,1.8,1.7C93.6,33.6,92.7,34.4,91.7,34.4z  M91.7,31.4c-0.7,0-1.3,0.6-1.3,1.2c0,0.7,0.6,1.2,1.3,1.2c0.7,0,1.3-0.6,1.3-1.2C93.1,32,92.5,31.4,91.7,31.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.0866,
    y1: 32.6639,
    x2: 99.7379,
    y2: 32.6639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M97.9,34.4c-1,0-1.8-0.8-1.8-1.7c0-0.9,0.8-1.7,1.8-1.7s1.8,0.8,1.8,1.7C99.7,33.6,98.9,34.4,97.9,34.4z  M97.9,31.4c-0.7,0-1.3,0.6-1.3,1.2c0,0.7,0.6,1.2,1.3,1.2s1.3-0.6,1.3-1.2C99.3,32,98.7,31.4,97.9,31.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.2658,
    y1: 32.6639,
    x2: 105.9172,
    y2: 32.6639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M104.1,34.4c-1,0-1.8-0.8-1.8-1.7c0-0.9,0.8-1.7,1.8-1.7c1,0,1.8,0.8,1.8,1.7 C105.9,33.6,105.1,34.4,104.1,34.4z M104.1,31.4c-0.7,0-1.3,0.6-1.3,1.2c0,0.7,0.6,1.2,1.3,1.2c0.7,0,1.3-0.6,1.3-1.2 C105.4,32,104.8,31.4,104.1,31.4z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M85.4,33.6h-38c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h38c0.5,0,0.9,0.4,0.9,0.9 C86.4,33.2,85.9,33.6,85.4,33.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 52.1634,
    y1: 20.3568,
    x2: 40.5693,
    y2: 48.5857
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M47.2,35l-4.3,4.4c-0.2,0.2-0.2,0.5,0,0.6l0,0c0.2,0.1,0.4,0.1,0.6-0.1l3.9-4.7L47.2,35z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 1264.6122,
    y1: 1108.568,
    x2: 1270.2963,
    y2: 1108.568,
    gradientTransform: "matrix(0.9025 -0.4307 0.4307 0.9025 -1572.2516 -421.9072)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M51.7,31.5c0.7,1.4,0.1,3.1-1.4,3.7c-1.4,0.7-3.1,0.1-3.8-1.3c-0.7-1.4-0.1-3.1,1.4-3.7 C49.3,29.5,51,30.1,51.7,31.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 53.8621,
    y1: 21.0545,
    x2: 42.268,
    y2: 49.2834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M47.7,29.9c-1.6,0.8-2.3,2.6-1.5,4.2c0.7,1.5,2.6,2.2,4.2,1.4c1.6-0.8,2.3-2.6,1.5-4.2 C51.2,29.8,49.3,29.1,47.7,29.9z M50.2,35.1c-1.3,0.6-2.9,0.1-3.6-1.2c-0.6-1.3-0.1-2.9,1.3-3.6c1.3-0.6,2.9-0.1,3.6,1.2 C52.2,32.8,51.6,34.4,50.2,35.1z"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M101.8,75.2H49.1c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h52.7c0.6,0,1.1,0.5,1.1,1.1 C102.9,74.7,102.4,75.2,101.8,75.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M101.8,79.4H49c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1h52.7c0.6,0,1.1,0.5,1.1,1.1 C102.8,78.9,102.4,79.4,101.8,79.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.1195,
    y1: 89.6756,
    x2: 83.8065,
    y2: 89.6756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M79.9,97.7H50c-2.2,0-3.9-1.8-3.9-3.9v-8.2c0-2.2,1.8-3.9,3.9-3.9h29.8c2.2,0,3.9,1.8,3.9,3.9v8.2 C83.8,95.9,82.1,97.7,79.9,97.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.2074,
    y1: 89.6756,
    x2: 104.2433,
    y2: 89.6756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M100.3,97.7H90.1c-2.2,0-3.9-1.8-3.9-3.9v-8.2c0-2.2,1.8-3.9,3.9-3.9h10.2c2.2,0,3.9,1.8,3.9,3.9v8.2 C104.2,95.9,102.5,97.7,100.3,97.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.7942,
    y1: 55.3957,
    x2: 82.1617,
    y2: 55.3957
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M82.2,55.4c0,3.4-2.8,6.2-6.2,6.2c-3.4,0-6.2-2.8-6.2-6.2c0-3.4,2.8-6.2,6.2-6.2 C79.4,49.2,82.2,52,82.2,55.4z M81.8,55.4c0-3.2-2.6-5.8-5.8-5.8c-3.2,0-5.8,2.6-5.8,5.8c0,3.2,2.6,5.8,5.8,5.8 C79.2,61.2,81.8,58.6,81.8,55.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.7568,
    y1: 55.4226,
    x2: 80.1996,
    y2: 55.4226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M74.2,58.6c-0.2,0-0.3-0.1-0.3-0.3l-0.1-5.5c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.3-0.1,0.5,0l5.4,2.5 c0.2,0.1,0.3,0.3,0.3,0.5c0,0.2-0.1,0.4-0.3,0.5l-4.8,2.5c-0.2,0.1-0.4,0-0.4-0.1c-0.1-0.2,0-0.4,0.1-0.4l4.6-2.4l-5-2.3 l0.1,5.3C74.6,58.4,74.4,58.6,74.2,58.6C74.2,58.6,74.2,58.6,74.2,58.6z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      opacity: 0.2
    },
    width: 564,
    height: 597,
    xlinkHref: "5C6A4FBA.png",
    transform: "matrix(0.24 0 0 0.24 -5.64 10.44)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 30.6601,
    y1: 66.0725,
    x2: 33.5389,
    y2: 4.3842
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M52.3,76.7L4.1,123c-2,1.9-2,5.2,0.1,7.1l0.3,0.3c1.9,1.7,4.7,1.5,6.3-0.4l44.5-50.4L52.3,76.7z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9151 -0.4032 0.4032 0.9151 -14.9536 33.9736)",
    className: "st22",
    cx: 73.2,
    cy: 52.5,
    rx: 31,
    ry: 30.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.132,
    y1: 6.2267,
    x2: 54.353,
    y2: 104.105
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M59.6,21.5c-17.4,7.7-25.5,27.8-17.9,44.9c7.5,17.1,27.8,24.8,45.2,17.1s25.5-27.8,17.9-44.9 C97.3,21.5,77,13.8,59.6,21.5z M84.9,79C70,85.5,52.7,79,46.3,64.4C39.8,49.8,46.7,32.6,61.6,26c14.9-6.6,32.2,0,38.6,14.6 C106.6,55.2,99.8,72.4,84.9,79z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M45.7,69.1c0,0-0.1,0-0.1-0.1c-0.4-0.7-0.8-1.4-1.2-2.1c0-0.1,0-0.1,0.1-0.2c0.1,0,0.1,0,0.2,0.1 c0.4,0.7,0.7,1.4,1.2,2.1C45.8,69,45.8,69.1,45.7,69.1C45.7,69.1,45.7,69.1,45.7,69.1z M42.1,60.3c-0.1,0-0.1,0-0.1-0.1 c-0.5-2.1-0.8-4.4-0.9-6.6c-0.1-6.3,1.6-12.4,4.9-17.8c3.5-5.5,8.5-9.8,14.5-12.4c5.6-2.5,11.8-3.3,17.9-2.5 c0.1,0,0.1,0.1,0.1,0.1c0,0.1-0.1,0.1-0.1,0.1c-6-0.9-12.1,0-17.7,2.4c-12,5.3-19.6,17-19.2,29.9c0.1,2.2,0.3,4.4,0.9,6.5 C42.2,60.3,42.1,60.3,42.1,60.3C42.1,60.3,42.1,60.3,42.1,60.3z"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M8.4,130C8.4,130,8.4,130,8.4,130c-2,0.2-3.4-0.4-4.1-1.8c-0.7-1.4-0.4-3,0.8-4.2l5.7-5.7c0,0,0.1,0,0.2,0 c0,0,0,0.1,0,0.2l-5.7,5.7c-1,1.1-1.3,2.6-0.7,3.9c0.6,1.2,1.9,1.8,3.8,1.6c0.1,0,0.1,0,0.1,0.1C8.6,129.9,8.5,129.9,8.4,130z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M12.7,116.7c0,0-0.1,0-0.1,0c0,0,0-0.1,0-0.2l0.7-0.7c0,0,0.1,0,0.2,0c0,0,0,0.1,0,0.2L12.7,116.7 C12.8,116.7,12.7,116.7,12.7,116.7z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighQuality);
export default __webpack_public_path__ + "static/media/highQuality.289c84fe6bbdf15c09bf541534eea20f.svg";
export { ForwardRef as ReactComponent };